import React from 'react';
// import { ErrorBoundary } from 'react-error-boundary';
import * as Sentry from '@sentry/react';

import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import config from '../../config';

const bugTrackerComponent = ({ errorComponent, children }) => {
    return (
        // <ErrorBoundary FallbackComponent={errorComponent} onError={notifyError}>
        //     {children}
        // </ErrorBoundary>
        <Sentry.ErrorBoundary fallback={errorComponent}>
            {children}
        </Sentry.ErrorBoundary>
    );
};

if(typeof window !== 'undefined' && config.sentry?.dsn?.client) {
    console.log('Sentry::: Init');
    Sentry.init({
        dsn: config.sentry.dsn.client,
        integrations: [
            // Sentry.browserTracingIntegration({
            //     ignoreResourceSpans: ['resouce.script', 'resource.css', 'resource.img'],
            // }),
            // Sentry.replayIntegration(),
            Sentry.reactRouterV7BrowserTracingIntegration({
                useEffect: React.useEffect,
                useLocation,
                useNavigationType,
                createRoutesFromChildren,
                matchRoutes,
            }),
        ],
        // Tracing
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: ['localhost', `/^${config.url}/`],
        // Session Replay
        replaysSessionSampleRate: 0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
        replaysOnErrorSampleRate: 0.01, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
        ignoreSpans: [
            '/.*\.css/',
            '/.*\.js/',
            '/.*\.png/',
            '/.*\.jpg/',
        ],
    });
} else {
    console.log('BugTracker::: Disabled');
}

export function notifyError(error, meta = {}) {
    // if(process.env.NODE_ENV === 'production') {
    // }
    console.log(meta);
    console.error(error);
    Sentry?.captureException(error, meta);
}

export function notifyMessage(message, type) {
    if(type === 'success') {
        type = 'log';
    }
    Sentry?.captureMessage(message, type);
}

export default bugTrackerComponent;
